/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ServicesIcon = props => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} {...props}>
			<g fill='#f7f7fb' stroke='#848588' strokeWidth={1.5} data-name='Grupo 18889'>
				<g data-name='Rect\xE1ngulo 85585' transform='translate(4 4)'>
					<rect width={8} height={8} stroke='none' rx={2} />
					<rect width={6.5} height={6.5} x={0.75} y={0.75} fill='none' rx={1.25} />
				</g>
				<g data-name='Rect\xE1ngulo 85583' transform='translate(4 13)'>
					<rect width={8} height={8} stroke='none' rx={2} />
					<rect width={6.5} height={6.5} x={0.75} y={0.75} fill='none' rx={1.25} />
				</g>
				<g data-name='Rect\xE1ngulo 85586' transform='translate(13 4)'>
					<rect width={8} height={8} stroke='none' rx={2} />
					<rect width={6.5} height={6.5} x={0.75} y={0.75} fill='none' rx={1.25} />
				</g>
				<g data-name='Rect\xE1ngulo 85584' transform='translate(13 13)'>
					<rect width={8} height={8} stroke='none' rx={2} />
					<rect width={6.5} height={6.5} x={0.75} y={0.75} fill='none' rx={1.25} />
				</g>
			</g>
			<path fill='none' d='M0 0h24v24H0z' data-name='Rect\xE1ngulo 85590' />
		</svg>
	)
}

export default ServicesIcon
